var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.182 4.801V14.988q0 1.785-1.208 2.993-1.154 1.154-2.792 1.209h2.331l8.69-8.633q-.886-2.21-2.704-4.029-3.51-3.51-8.46-3.51-5.008 0-8.519 3.51-3.51 3.51-3.51 8.46 0 5.008 3.51 8.518 3.511 3.511 8.518 3.511 4.95 0 8.46-3.51 3.512-3.511 3.512-8.519 0-2.386-.806-4.431m-7.022 4.316q-.041-1.653-1.208-2.82-1.209-1.208-2.936-1.208h-.115q-1.099.024-1.985.518L11.44 12.83q-.604.95-.604 2.158 0 .324.029.634.114.794.489 1.467l1.468 1.497q.958.604 2.215.604h.144m-2.244-7.827q-.475.273-.892.69-.363.363-.605.777l-7.108 6.878m6.533-4.086-.029 10.187m.518-8.72q.274.476.69.892.358.358.778.605l6.877 7.107M4.794 10.845h10.13m-4.317-6.216 8.575 8.46m-1.669 6.1h8.288"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(1 0 0 1 .017 .024)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModel);
export default __webpack_public_path__ + "static/media/icon-model.9bd8433b460950064040c419f9ab993c.svg";
export { ForwardRef as ReactComponent };